import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, catchError, map, throwError } from 'rxjs';
import { PagesForAdminService, PagesForUserService } from '@src/api';
import { AlertService } from '@src/core/services';

import { PageInfoType } from '../types';

@Injectable({
  providedIn: 'root',
})
export class PageInfoService {
  private readonly pagesForAdminService = inject(PagesForAdminService);
  private readonly pagesForUserService = inject(PagesForUserService);
  private readonly alertService = inject(AlertService);

  pageInfo$ = new BehaviorSubject<PageInfoType | null>(null);

  loadPageInfo(id: string) {
    this.pagesForUserService
      .getPage(id)
      .pipe(
        catchError(err => {
          this.alertService.error(err);

          return throwError(() => err);
        }),
        map(pageInfo => this.sortingContacts(pageInfo)),
      )
      .subscribe(pageInfo => this.pageInfo$.next(pageInfo));
  }

  resetPageInfo() {
    this.pageInfo$.next(null);
  }

  createPageInfo(data: PageInfoType) {
    return this.pagesForAdminService.addPage(data).pipe(
      catchError(err => {
        this.alertService.error(err);

        return throwError(() => err);
      }),
    );
  }

  editPageInfo(data: PageInfoType) {
    return this.pagesForAdminService.editPage(data).pipe(
      catchError(err => {
        this.alertService.error(err);

        return throwError(() => err);
      }),
    );
  }

  deletePageInfo(id: string) {
    return this.pagesForAdminService.deletePage(id).pipe(
      catchError(err => {
        this.alertService.error(err);

        return throwError(() => err);
      }),
    );
  }

  private sortingContacts(pageInfo: PageInfoType): PageInfoType {
    pageInfo.contacts
      ?.sort((a, b) => a.sortOrder! - b.sortOrder!)
      .map((contact, index) => {
        contact.sortOrder = (index + 1) * 10;
        return contact;
      });

    return pageInfo;
  }
}
